module.exports = __webpack_public_path__ + "img/logo@2x.31eb5950.png";